import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSalas } from 'services/servicioGet';
import { Sala } from 'utils/models/types';

interface SalasState {
  salas: Sala[];
  loadingSalas: boolean;
  errorSalas: string | null;
}

// Estado inicial del slice
const initialState: SalasState = {
  salas: [],
  loadingSalas: false,
  errorSalas: null,
};

// Thunk para obtener las salas
export const fetchSalas = createAsyncThunk('salas/fetchSalas', async (_, { rejectWithValue }) => {
  try {
    const response = await getSalas();
    return response;
  } catch (error: unknown) {
    return rejectWithValue(error instanceof Error ? error.message : String(error));
  }
});

// Slice de salas
const salasSlice = createSlice({
  name: 'salas',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchSalas.pending, state => {
        state.loadingSalas = true;
        state.errorSalas = null;
      })
      .addCase(fetchSalas.fulfilled, (state, action) => {
        state.salas = action.payload;
        state.loadingSalas = false;
      })
      .addCase(fetchSalas.rejected, (state, action) => {
        state.loadingSalas = false;
        // Capturamos el mensaje de error que devolvió por rejectWithValue
        state.errorSalas = action.payload as string;
      });
  },
});

export default salasSlice.reducer;
